module.exports = __webpack_public_path__ + "static/logo_authre_chose-9570196adb81b6e76d379f913d467f0f.png";